import template from '@components/expertise/discovery/discovery.module.scss'
import { ISDLCSection } from '../../discovery.state';
import style from './index.module.scss'
import Image from 'next/image'
import { TextImageBlock } from '@components/shared/blocks/text-image-block';

interface ISDLCSectionProps {
    section: ISDLCSection;
}

const SDLCSectionComponent = ({ section }: ISDLCSectionProps) => {
    return (
        <section className={`${template.section} ${template.section__block_light} ${style.section}`}>
            <div className={template.container}>
                <TextImageBlock title={section.title} text={[section.text]} imageSrc={section.imgSrc} imageAlt={section.title} />
            </div>
        </section>
    )
}

export default SDLCSectionComponent;